import * as URLConfig from "@frameworks/web/config/domain";
var config = URLConfig.config;
var encriptionConfigURL = {
    serverKey: "https://auth.nuvamawealth.com/app-auth/keys/server-public-key",
};
export default encriptionConfigURL;
